module.exports = __webpack_public_path__ + "img/prev-dash.c3859780.png";